// src/components/PropertyPanel/utils/propertyUtils.js
import axios from 'axios';

// 이미지 업로드 핸들러
export const handleImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return null;

  // 파일 유형 확인
  const isVideo = file.type.startsWith('video/');
  const fileType = isVideo ? '영상' : '이미지';

  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bucket', 'withcookie-bucket');
    formData.append('path', 'c/default');

    const res = await axios.post(
      `https://refrigerator.logipasta.com/v1/file`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*',
        },
        timeout: 30000,
      }
    );

    if (res.data && res.data.file) {
      // 파일 유형에 따라 다른 메시지 표시
      alert(`${fileType}(가) 성공적으로 업로드되었습니다.`);
      return res.data.file;
    } else {
      console.error(`${fileType} URL이 응답에 없습니다:`, res.data);
      alert(`서버 응답에 ${fileType} URL이 포함되어 있지 않습니다. 관리자에게 문의하세요.`);
      return null;
    }
  } catch (err) {
    console.error(`${fileType} 업로드 실패:`, err);
    
    let errorMessage = `${fileType} 업로드에 실패했습니다. `;
    
    if (err.response) {
      console.error('서버 응답 오류:', err.response.status, err.response.data);
      errorMessage += `서버 응답 오류 (${err.response.status}): ${JSON.stringify(err.response.data)}`;
    } else if (err.request) {
      console.error('서버 응답 없음:', err.request);
      errorMessage += '서버로부터 응답이 없습니다. 네트워크 연결을 확인해주세요.';
    } else if (err.code === 'ECONNABORTED') {
      errorMessage += '요청 시간이 초과되었습니다. 나중에 다시 시도해주세요.';
    } else {
      console.error('요청 오류:', err.message);
      errorMessage += err.message;
    }
    
    alert(errorMessage);
    return null;
  }
};

// 디바이스별 속성값 가져오기 함수
export const getDevicePropertyValue = (source, field, defaultValue, devicePropertyTab) => {
  if (!source) return defaultValue;
  
  try {
    // deviceProperty 객체가 있고, 현재 선택된 디바이스 탭에 해당 필드가 있는 경우
    if (source.deviceProperty && 
        source.deviceProperty[devicePropertyTab] && 
        source.deviceProperty[devicePropertyTab][field] !== undefined) {
      
      return source.deviceProperty[devicePropertyTab][field];
    }
    
    // 디바이스별 설정이 없는 경우, 최상위 필드 확인
    if (source[field] !== undefined) {
      return source[field];
    }
    
    // 모든 경우에 해당 없으면 기본값 반환
    return defaultValue;
  } catch (err) {
    console.error(`getDevicePropertyValue 오류:`, err);
    return defaultValue;
  }
};